import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";

export class ModWebProductDetail extends ModuleComponent{
    ready(){
        super.ready();

        this.findMember("back-link").click(
            (ev)=>{
                ev.preventDefault();
                window.history.back();
            }
        );

        const modalImgContainer = document.getElementById("imageModal");
        const modalImg = document.getElementById('modalImg');

        this.findMember("show-highlight-product-image").click(
            (ev)=>{
                ev.preventDefault();
                const imageId = ev.currentTarget.dataset.feature;
                updateImageUrl(imageId);
            }
        );

        this.findMember("close-highlight-image").click(
            (ev)=>{
                ev.preventDefault();
                modalImgContainer.style.display = "none";
            }
        );

        function updateImageUrl(imageId) {
            GvfService.endpoint('/web/web-product/get-feature-img-url', {
                imageId: imageId,
            }).then((resp) => {
                if (resp.src) {
                    modalImg.src = resp.src;
                    setTimeout(() => {
                        modalImgContainer.style.display = "flex";
                    },300);
                }
            });
        }

        const featureItems = document.querySelectorAll(this.scope+"__show-modal");
        featureItems.forEach(item => {
            item.addEventListener("click", () =>{
                const imageId = item.getAttribute('data-feature');
                updateImageUrl(imageId);
            });
        });
    }
}
